import { render, staticRenderFns } from "./XGplayer.vue?vue&type=template&id=2e6e2b70"
import script from "./XGplayer.vue?vue&type=script&lang=ts"
export * from "./XGplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports